export default "__VITE_ASSET__fhflFGwZ__"